export const GET_MAGAZINE_COMPLAINT = "GET_MAGAZINE_COMPLAINT";
export const UPDATE_FILTER_MAGAZINE_COMPLAINTS = "UPDATE_FILTER_MAGAZINE_COMPLAINTS";